import ApiService from './api.service'

const AIService = {
  extractTeamDataFromText (text) {
    return ApiService.postWithoutLoading('api/ai/extract-team-data-from-text', {
      text
    })
  }
}

export default AIService
